export const getEstacaoMeteorologica = (state) => state.estacaoMeteorologica.lista
export const getIsCarregandoListaEstacaoMeteorologica =
  (state) => state.estacaoMeteorologica.isCarregandoLista
export const getIsSavingEstacaoMeteorologica = (state) => state.estacaoMeteorologica.isSaving
export const getIsUpdatingEstacaoMeteorologica = (state) => state.estacaoMeteorologica.isUpdate
